import { FC, SVGAttributes } from "react";

const BrandsIcon: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}
  >
    <defs>
      <path id="av1k5o62fa" d="M0 0H32V32H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-16 -267) translate(16 267)">
        <mask id="4fkg4f7t7b" fill="#fff">
          <use xlinkHref="#av1k5o62fa" />
        </mask>
        <g mask="url(#4fkg4f7t7b)">
          <g transform="translate(2 4)">
            <path
              fill="#000"
              fillRule="nonzero"
              d="M4 3.219v4.895l-1.019 2.29c-.09.201-.11.426-.059.638l.04.126 4.054 10.563c.182.475.69.732 1.172.612l.12-.037 4.034-1.55 1.548 1.548-4.866 1.869c-1.546.594-3.282-.179-3.876-1.726L1.094 11.885c-.285-.743-.264-1.568.06-2.295l2.749-6.173c.03-.068.062-.134.096-.198z"
            />
            <path
              stroke="#000"
              strokeWidth="2"
              d="M15.757 1c.53 0 1.04.21 1.415.586h0l9 9c.39.39.585.902.585 1.414 0 .512-.195 1.024-.585 1.414h0l-7.758 7.758c-.39.39-.902.585-1.414.585-.512 0-1.024-.195-1.414-.585h0l-9-9C6.21 11.797 6 11.288 6 10.757h0V3c0-.552.224-1.052.586-1.414C6.948 1.224 7.448 1 8 1h0z"
            />
            <circle cx="10.5" cy="5.5" r="1.5" fill="#000" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export { BrandsIcon };
